if (document.getElementsByClassName('banner-info')[0]) {
    /**
     * Variables
     *
     * @type {Element}
     */
    var buttonBannerInfo = document.getElementsByClassName('banner-info__button')[0];
    var isActiveButton = 'banner-info__button_active';
    var isOpenForm = 'info-form_open';
    var infoForm = document.getElementsByClassName('info-form')[0];

    /**
     * Event click on menu button
     */
    buttonBannerInfo.addEventListener('click', function () {

        if (this.classList.contains(isActiveButton)) {
            this.classList.remove(isActiveButton);
            closeForm();
        } else {
            this.classList.add(isActiveButton);
            openForm();
        }

    });

    /**
     * Function opening menu
     */
    function openForm() {
        infoForm.classList.add(isOpenForm);
    }

    /**
     * Function closing menu
     */
    function closeForm() {
        infoForm.classList.remove(isOpenForm);
    }
}